import React from "react";
import {useTranslation} from "react-i18next";
import PriorityScoreBreakdown from "features/incidents/PriorityScore/PriorityScoreBreakdown";
import {CollapsibleDrawerContent} from "components/Drawer";
import EmptyContent from "components/EmptyContent";

const PriorityScoreSection = ({incident}) => {
  const {t} = useTranslation();

  return (
    <CollapsibleDrawerContent
      key={incident.id}
      defaultCollapsed={!incident?.scores}
      title={t("incidents.priorityScore.title")}>
      {incident?.scores ? (
        <PriorityScoreBreakdown showGlobalScore {...{incident}} />
      ) : (
        <EmptyContent name="priority score" />
      )}
    </CollapsibleDrawerContent>
  );
};

export default PriorityScoreSection;
